import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { color } from "../../../../theme";
import { Wrapper } from "./styles";

export const Button = ({ label, suffix, prefix, color, type, ...props }) => {
  return (
    <Wrapper className="cg-button" type={type} color={color} {...props}>
      {prefix && (
        <FontAwesomeIcon
          icon={prefix}
          color={color}
          style={{ marginRight: "10px" }}
        />
      )}
      {label}
      {suffix && (
        <FontAwesomeIcon
          icon={suffix}
          color={color}
          style={{ marginLeft: "10px" }}
        />
      )}
    </Wrapper>
  );
};

Button.defaultProps = {
  suffix: null,
  prefix: null,
  label: "Default Button",
  color: color.white,
  type: "primary",
};
